import { actions } from './actions';

const initialState = {
  iconName: null,
  runTime: null,
  animationName: null
};

const effect = (state = initialState, action) => {
  switch (action.type) {
    case actions.RUN_PLAYER_EFFECT:
      return {
        ...state, ...action.payload
      };
    default:
      return state;
  }
};

export default effect;
